import React, { Component } from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import theme from "../styles/theme"

import Logo from "../images/logo.svg"

const Inner = styled.div`
  max-width: ${theme.maxwidth.default};
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  display: flex;
  a {
    color: ${theme.color.ink};
    text-decoration: none;
  }
  > * + * {
    margin-left: 16px;
  }
  @media (max-width: ${theme.breakpoints.tablet}) {
    height: 100%;
    flex-direction: column;
    justify-content: center;
    > * + * {
      margin-left: 0;
      margin-top: 16px;
    }
  }
`

const Button = styled.a`
  border: none;
  padding: 8px 16px;
  background: ${theme.color.accent};
  color: ${theme.color.ink};
  border-radius: ${theme.border.default};
`
const LogoImg = styled.img`
  height: 28px;
`
const LogoContainer = styled.div`
  margin-top: 0;
  margin-right: auto;
  @media (max-width: ${theme.breakpoints.tablet}) {
    position: fixed;
    top: 32px;
    left: 32px;
  }
  a {
    img {
      margin: 0;
    }
  }
`

const Hamburger = styled.div`
  display: none;
  margin: 0;
  z-index: 2;
  @media (max-width: ${theme.breakpoints.tablet}) {
    display: block;
    position: fixed;
    width: 32px;
    height: 28px;
    top: 32px;
    right: 32px;
  }
`

const HTop = styled.div`
  position: absolute;
  width: 32px;
  height: 3px;
  background: ${theme.color.ink};
  top: 0;
  left: 0;
`
const HMid = styled.div`
  position: absolute;
  width: 32px;
  height: 3px;
  background: ${theme.color.ink};
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
`
const HBot = styled.div`
  position: absolute;
  width: 32px;
  height: 3px;
  background: ${theme.color.ink};
  bottom: 0;
  left: 0;
`

export default class Nav extends Component {
  state = {
    on: false,
  }
  toggle = () => {
    this.setState({
      on: !this.state.on,
    })
  }
  render() {
    const Container = styled.div`
      width: 100%;
      padding: 32px 32px 64px 32px;
      @media (max-width: ${theme.breakpoints.tablet}) {
        background: #fff;
        height: 100%;
        width: 100%;
        position: fixed;
        z-index: 1;
        transition: 0.4s;
        ${state =>
          this.state.on
            ? { opacity: 1, userSelect: "all", pointerEvents: "all" }
            : { opacity: 0, userSelect: "none", pointerEvents: "none" }};
      }
    `
    console.log(this.state)
    return (
      <>
        <Hamburger onClick={this.toggle}>
          <HTop />
          <HMid />
          <HBot />
        </Hamburger>
        <Container>
          <Inner>
            <LogoContainer>
              <Link to="/">
                <LogoImg src={Logo} alt="Stack Logo"></LogoImg>
              </Link>
            </LogoContainer>
            <Link to="/what-is-stack">What is stack?</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
            <Button href="https://app.stackglobal.io/login">Log In</Button>
            <Button href="https://app.stackglobal.io/app">Get Started</Button>
          </Inner>
        </Container>
      </>
    )
  }
}
